import InformationBar, {
  barItems
} from "@/components/common/shared/InformationBar/InformationBar"
import {
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  makeStyles,
  Typography
} from "@material-ui/core"
import CloseIcon from "@material-ui/icons/Close"
import React, { ReactNode } from "react"

const useStyles = makeStyles(theme => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  },
  title: {
    paddingBottom: 0
  }
}))

type ModalHeaderProps = {
  children?: ReactNode
  infoBarData?: barItems
  onClose?: () => void
}
const ModalHeader: React.FC<ModalHeaderProps> = ({
  children,
  infoBarData,
  onClose
}: ModalHeaderProps) => {
  const classes = useStyles()

  return (
    <>
      <DialogTitle disableTypography className={classes.title}>
        <Grid item container>
          <Grid item xs={9}>
            <Typography variant="h6">{children}</Typography>
          </Grid>
          <Grid item xs={3}>
            {onClose ? (
              <IconButton
                aria-label="close"
                className={classes.closeButton}
                onClick={onClose}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </Grid>
        </Grid>
      </DialogTitle>
      {infoBarData ? (
        <DialogContent>
          <DialogContentText>
            <Grid item container>
              <Grid item xs={12}>
                <InformationBar data={infoBarData} />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      ) : (
        <></>
      )}
    </>
  )
}
export default ModalHeader
